// 포커스에이아이 NVR [CSV 등록] 형식 — 맵에디터 내보내기와 NVR 템플릿 문서가 같이 쓴다.
// jointjs 를 끌어오지 않게 nvrTemplate.ts 와 따로 둔다.

// 포커스에이아이 NVR 웹 [CSV 등록] 샘플(camera_registration_template.csv) 1행 헤더 그대로
export const FOCUSAI_HEADER = [
  'protocol', 'ip', 'onvifAddress', 'onvifRtspPort', 'channel',
  'brand', 'model', 'id', 'password', 'title',
] as const

function csvCell(value: string | number): string {
  const s = String(value)
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
}

/** 행(헤더 포함)을 샘플과 같은 CSV 로 — BOM 없이 CRLF, 마지막 줄도 CRLF. */
export function focusAiCsvText(rows: ReadonlyArray<ReadonlyArray<string | number>>): string {
  return rows.map(r => r.map(csvCell).join(',') + '\r\n').join('')
}
